const dashboardUrlRegex = /^\/([0-9a-f]{32})\//;

export default function getDashboardIfFromUrl(url) {
	const result = url.match(dashboardUrlRegex);
	return result?.[1];
}
